module.exports = " <div class=discover _v-e5f0562a=\"\"> <title-bar title=发现 _v-e5f0562a=\"\"></title-bar> <div class=body _v-e5f0562a=\"\"> <form action=\"\" @submit.prevent=search _v-e5f0562a=\"\"> <search-bar :keyword.sync=keyword _v-e5f0562a=\"\"></search-bar> </form> <list :list=users list-type=user _v-e5f0562a=\"\"></list> <list :list=groups list-type=group _v-e5f0562a=\"\"></list> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e5f0562a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/Discover.vue
 ** module id = 368
 ** module chunks = 2
 **/